angular.module('components.caBudgetImport', [])
.component('caBudgetImport', {
    templateUrl: 'main/budget/budgets/components/budgetImport.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        disabledBy: '<',
        onBudgetImported: '&'
    },
    controller: controller
});

// @ngInject
function controller(GenericComponentService, $translate, loadSpinnerService, confirmationDialogService)  {
    var vm = this;

    vm.importData = [];

    var fileInputDomElement = $("#xlf")[ 0 ];

    fileInputDomElement.addEventListener('change', handleFile, false);

    function handleFile(element) {
        var file = element.target.files[0];

        var reader = new FileReader();
        reader.onload = onLoadFunction;
        reader.readAsArrayBuffer(file);
    }

    function onLoadFunction(e) {
        try {
            loadSpinnerService.start('mainSpinner');

            var data = "";
            var bytes = new Uint8Array(e.target.result);
            var length = bytes.byteLength;
            for (var i = 0; i < length; i++) {
                data += String.fromCharCode(bytes[i]);
            }
            var workbook = XLSX.read(data, {type: 'binary'});

            var firstSheetName = workbook.SheetNames[0];

            var workSheet = workbook.Sheets[firstSheetName];

            vm.importData = XLSX.utils.sheet_to_json(workSheet);

            confirmationDialogService.showDialog($translate.instant('budget.numberOfRows') + ": " + vm.importData.length).then(function (result) {
                if (result === true) {
                    vm.onBudgetImported({budgets:vm.importData});
                }
                $("#xlf")[ 0 ].value = "";
            });

        } catch (error) {
            console.error(error);
        } finally {
            loadSpinnerService.stop('mainSpinner');
        }
    }
}
